module.exports = __webpack_public_path__ + "images/stickers/taco-embarrassed.f3b24ef7a5d27097ab86.png";